import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelfLearnChapterComponent } from './components/self-learn-chapter/self-learn-chapter.component';
import { SelfLearnHomeComponent } from './components/self-learn-home/self-learn-home.component';
import { SelfLearnSubjectComponent } from './components/self-learn-subject/self-learn-subject.component';
import { SelfLearnVideoPlaybackComponent } from './components/self-learn-video-playback/self-learn-video-playback.component';
import { SelfLearnVideosComponent } from './components/self-learn-videos/self-learn-videos.component';
import { TopicSummaryDetailsComponent } from './components/topic-summary-details/topic-summary-details.component';
import { TopicsSummaryComponent } from './components/topics-summary/topics-summary.component';
import { PracticeQuestionsComponent } from './components/practice-questions/practice-questions.component';
import { ShortsComponent } from './components/shorts/shorts.component';
import { ParcticeCompletionComponent } from './components/parctice-completion/parctice-completion.component';
import { PracticeTopicListComponent } from './components/practice-topic-list/practice-topic-list.component';
import { ReviceQuestionsComponent } from './components/revice-questions/revice-questions.component';
import { ReviseCompletionComponent } from './components/revise-completion/revise-completion.component';
import { DocumentsPageComponent } from './components/documents-page/documents-page.component';
import { ViewPdfComponent } from './components/view-pdf/view-pdf.component';
import { MyLibraryComponent } from './components/my-library/my-library.component';
import { ExerciseCompletionComponent } from './components/exercise-completion/exercise-completion.component';
import { MemoryCardsComponent } from './components/memory-cards/memory-cards.component';
import { CardOfTheDayComponent } from './components/card-of-the-day/card-of-the-day.component';
import {ExerciseQuestionsComponent} from './components/exercise-questions/exercise-questions.component';
import {ExerciseSolutionComponent} from './components/exercise-solution/exercise-solution.component'

import { BookmarksListComponent } from './components/bookmarks-list/bookmarks-list.component';
import { PypChapterQuestionsComponent } from './components/pyp-chapter-questions/pyp-chapter-questions.component';
import { PyqChapterCompletionComponent } from './components/pyq-chapter-completion/pyq-chapter-completion.component';
import { HistoryListComponent } from './components/history-list/history-list.component';



const routes: Routes = [
  { path: '', component: SelfLearnHomeComponent },
  { path: 'subject', component: SelfLearnSubjectComponent },
  { path: 'videos', component: SelfLearnVideosComponent },
  { path: 'videoplayback', component: SelfLearnVideoPlaybackComponent },
  { path: 'chapter', component: SelfLearnChapterComponent },
  { path: 'topic-summary', component: TopicsSummaryComponent },
  { path: 'topic-summary-details', component: TopicSummaryDetailsComponent },
  { path: 'practice-questions', component: PracticeQuestionsComponent },
  { path: 'shorts', component: ShortsComponent },
  { path: 'practice-completion', component: ParcticeCompletionComponent },
  { path: 'practice-topics', component: PracticeTopicListComponent },
  { path: 'revise-questions', component: ReviceQuestionsComponent},
  { path: 'revise-completion' , component: ReviseCompletionComponent},
  { path: 'documents', component: DocumentsPageComponent },
  {path:'view-pdf',component: ViewPdfComponent},
  { path: 'my-library', component: MyLibraryComponent },
  { path: 'exercise-completion', component: ExerciseCompletionComponent },
  { path:'view-pdf',component: ViewPdfComponent},
  { path:'memory-card',component: MemoryCardsComponent},
  { path:'card-of-the-day',component: CardOfTheDayComponent},
  {path:'exercise-questions',component:ExerciseQuestionsComponent},
  { path: 'exercise-completion', component: ExerciseCompletionComponent },
  { path: 'exercise-solution', component: ExerciseSolutionComponent },

  { path: 'bookmarks', component: BookmarksListComponent },
  { path:'pyp-chapter-questions',component:PypChapterQuestionsComponent},
  { path:'pyp-chapter-completion',component:PyqChapterCompletionComponent},
  { path:'my-history',component:HistoryListComponent}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelfLearnV2RoutingModule { }
